import type { JSONContent } from '@tiptap/react';
import { isEmptyMessageBubble } from './flowEditorBlockNodeTypes';

// Drop empty placeholder bubbles from a node's tiptap doc. Returns null when there
// is nothing to prune, so callers can skip a redundant write. Pure: a fresh doc,
// the input untouched.
export function pruneEmptyMessageBubbles(doc: JSONContent | undefined): JSONContent | null {
  if (!doc?.content?.length) {
    return null;
  }
  const kept = doc.content.filter((block) => !isEmptyMessageBubble(block));
  if (kept.length === doc.content.length) {
    return null;
  }
  return { ...doc, content: kept };
}
